<style>
.EventsTable .table__container--panel {
  background-color: #f5f7f7;
  color: #757575;
  border: 1px 1px 0px 1px solid #bdc3c7;
  border-width: 1px 1px 0px 1px;
  border-style: solid;
  border-color: rgb(189, 195, 199);
}
.EventsTable .table__container--panel p {
  font-size: 12px;
}
.EventsTable .table__container--separator {
  border-right: 1px solid rgba(189, 195, 199, 0.5);
  content: " ";
  height: 8px;
  margin-top: 8px;
  position: relative;
  right: 0;
  top: 0;
}
.EventsTable .table__container--filter {
  margin: 3px;
  border: 1px solid rgba(189, 195, 199, 0.5);
  font-size: 12px;
}
</style>

<template>
  <v-layout
    row
    fill-height
    wrap
    class="EventsTable"
  >
    <ExportTableData
      ref="pobierz"
      :column-defs="columnDefs"
      :grid-options="gridOptions"
    ></ExportTableData>
    <v-layout
      class="table__container--panel"
      wrap
    >
      <v-icon
        style="padding-left: 10px"
        title="Pobierz"
        @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event), resizeColumns()"
      >description</v-icon>
      <v-layout
        align-right
        justify-end
      >
        <div style="margin-top: auto; margin-bottom: auto;">
          <p style="line-height:29px">Liczba wyników: {{numberFiltered}}/{{numberAll}}</p>
        </div>
        <input
          type="text"
          class="table__container--filter"
          v-model="filter"
          placeholder="Treść filtra"
        >
      </v-layout>
      <div class="table__container--separator"></div>
    </v-layout>
    <ag-grid-vue
      style="width: 100%; height: 90%;"
      class="ag-theme-balham"
      :gridOptions="gridOptions"
    ></ag-grid-vue>
  </v-layout>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import ExportTableData from "../../shared/ExportTableData";

export default {
  name: "App",
  props: {
    user: Number
  },
  data: () => ({
    tableTitle: "eventsTable",
    filter: "",
    numberAll: 0,
    numberFiltered: 0,
    columnDefs: [],
    dict: [],
    gridOptions: {
      rowData: [],
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
      overlayNoRowsTemplate:
        '<span class="ag-overlay-loading-center">Brak zdarzeń dla podanego użytkownika</span>',
      enableSorting: "true",
      enableFilter: "true",
      enableColResize: "true",
      onFilterModified: this.filteredNumber,
      onGridReady: this.onGridReady,
      onColumnMoved: this.onColumnMoved,
      onColumnResized: this.onColumnMoved,
      onFilterChanged: this.filterColumn,
      localeText: {
        contains: "Zawiera",
        notContains: "Nie zawiera",
        equals: "Równa się",
        notEqual: "Nie równa się",
        startsWith: "Zaczyna się",
        endsWith: "Kończy się",
        noRowsToShow: "Brak danych"
      },
      rowModelType: "infinite",
      paginationPageSize: 25,
      cacheBlockSize: 25,
      infiniteInitialRowCount: 5,
      maxConcurrentDatasourceRequests: 1,
      cacheOverflowSize: 2,
      enableServerSideSorting: true,
      enableServerSideFilter: true
    }
  }),
  components: {
    AgGridVue,
    ExportTableData
  },
  computed: {
    eventUser() {
      return this.$store.getters.getEventUser;
    },
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    events() {
      return this.$store.getters.getEvents;
    },
    eventUser: {
      // User chosen to get events for
      get() {
        return this.$store.getters.getEventUser;
      }
    }
  },
  beforeMount() {
    this.dict = [
      {
        headerName: "ID zdarzenia",
        field: "id",
        filter: "agNumberColumnFilter"
      },
      {
        headerName: "Opis",
        field: "description"
      },
      {
        headerName: "ID obiektu",
        field: "object_id"
      },
      {
        headerName: "Tabela obiektu",
        field: "object_table"
      },
      {
        headerName: "Typ obiektu",
        field: "object_type"
      },
      {
        headerName: "Data dodania",
        field: "created_at",
        cellRenderer: date => {
          return new Date(date.value).toLocaleString("pl-PL", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          });
        }
      }
    ];
    this.dict.forEach(field => {
      this.columnDefs.push(field);
    });
  },
  methods: {
    filterColumn() {
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length.toString();
    },
    showNoRowsMessage() {
      let dataSource = {
        getRows(params) {
          params.successCallback([], 0);
        }
      };
      this.gridOptions.api.setDatasource(dataSource);
      this.gridOptions.api.showNoRowsOverlay();
    },
    filteredNumber(e) {
      this.numberFiltered = this.gridOptions.api.getModel().getRowCount();
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      if(localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if(columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
    },
    refreshGrid() {
      this.gridOptions.api.hideOverlay();
      this.gridOptions.api.setColumnDefs(this.columnDefs);
      this.numberAll = this.events.length;
      this.numberFiltered = this.numberAll;
    },
    infiniteScroll() {
      const self = this;
      let data = this.events;
      let lastEvent = data.length > 0 ? data[data.length - 1] : undefined;
      const dataSource = {
        rowCount: null, // behave as infinite scroll
        getRows(params) {
          const payload = {
            user: self.eventUser.id,
            limit: 30,
            object_id: self.gridOptions.api.getFilterModel().object_id ? self.gridOptions.api.getFilterModel().object_id.filter : undefined,
            object_type: self.gridOptions.api.getFilterModel().object_type ? self.gridOptions.api.getFilterModel().object_type.filter : undefined,
            object_table: self.gridOptions.api.getFilterModel().object_table ? self.gridOptions.api.getFilterModel().object_table.filter : undefined
          };
          if (lastEvent) {
            payload.last = lastEvent.id;
          }
          if (self.filter !== '') {
            payload.search_text = self.filter;
          }
          self.$store.dispatch("getEvents", payload).then(r => {
            if(!r) {
              this.$root.$emit(
                "showSnackbar",
                "red",
                "Błąd pobierania listy zdarzeń dla użytkownika"
              );
              params.failCallback();
            } else {
              data = data.concat(r.data.events);
              self.numberAll = data.length;
              self.numberFiltered = data.length;
              lastEvent = data[data.length - 1];
              const rowsThisPage = data.slice(params.startRow, params.endRow);
              const lastRow = data.length <= params.endRow ? data.length : -1;
              params.successCallback(rowsThisPage, lastRow);
            }
          });
        }
      };
      this.gridOptions.api.setRowData([]);
      this.gridOptions.api.setDatasource(dataSource);
      this.gridOptions.api.purgeInfiniteCache();
    },
    onChanged() {}
  },
  watch: {
    filter(nV) {
      //this.gridOptions.api.setQuickFilter(nV);
      this.$store.commit("setEvents", []); //czyszczenie już ściągnientych events
      this.infiniteScroll(); //ponowne inicjalizowanie zaciągania opóźnienego
    }
  },
  mounted() {
    this.$root.$on("refreshUserEvents", this.refreshGrid);
    this.$root.$on("refreshUserEvents", this.infiniteScroll);
    this.$root.$on("showNoRowsMessage", this.showNoRowsMessage);
  },
  beforeDestroy() {
    //WAŻNE!!! odłączać listenery bo potem kilkukrotnie coś sie wywołuje po zamknięci / otwarciu okna, bo się zakłada ponownie
    this.$root.$off("refreshUserEvents", this.refreshGrid);
    this.$root.$off("refreshUserEvents", this.infiniteScroll);
    this.$root.$off("showNoRowsMessage", this.showNoRowsMessage);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/EventsTable.vue